module.exports = __webpack_public_path__ + "static/media/undraw_content_team_3epn.08f23162.png";